import { makeStyles } from '../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
        '&.MuiDialogActions-spacing > :not(:first-child)': {
            marginLeft: theme.spacing(1),
        },
    },
}));
//# sourceMappingURL=DialogActions.styles.js.map